<template>
  <p class="tw-m-0 darkSecondary--text"><slot /></p>
</template>

<script>
export default {
  name: "AtomTextSecondary",
  props: ["text"]
};
</script>